import PropTypes from 'prop-types';
import {useState} from 'react';
import { reduxForm } from 'redux-form';
import Dialog from 'infrastructure/js/components/Dialog/dialog';
import InputSection from 'infrastructure/js/components/Dialog/InputSection/inputSection';
import TextAreaField from 'infrastructure/js/components/controls/TextAreaField/textAreaField';
import {qplAcceptanceDecisionTypes} from '../../../../enums/qplAcceptanceDecisionTypes';
import PermissionManager from 'infrastructure/js/utils/permissionManager';
import useLabels from 'infrastructure/js/hooks/useLabels';
import PL_FilePicker from 'infrastructure/js/components/controls/FilePicker/filePicker';
import {getCoCAttachmentAcceptGenericTypes} from '../../../CoC/utils/cocHelper';

import './qplAcceptanceDecisionDialog.scss';

export function QplAcceptanceDecisionDialog({
                                             actions,
                                             sData,
                                             handleSubmit,
                                             reloadParentComponent = null,
}) {
  const dialogLabels = useLabels('mat.dialog.');
  const labels = useLabels('mat.administration.matsettings.pendingRequests.dialog.qplAcceptanceDecision.');

  const [selectedFile, setSelectedFile] = useState(null);
  const [errors, setErrors] = useState(null);

  const dialogData = sData?.get('dialogData');
  const isAccept = dialogData?.decision === qplAcceptanceDecisionTypes.ACCEPTED;
  const titleKey = isAccept ? 'header.title.accept' : 'header.title.decline';

  const loggedInUser = PermissionManager.getLoggedInUser();

  const onSubmit = (data) => {
    let newData = {
      reasoningText: data.comments,
      setId: dialogData.setId,
      decision: dialogData.decision,
      file: selectedFile,
    };

    actions.submit(newData, null, reloadParentComponent);
  };

  const onHide = () => {
    actions.hide();
  };

  const isLoading = () => {
    return sData?.get('loading');
  }

  const handleSelectedFileChanged = (file) => {
    const maxFileSize = PermissionManager.getOrgPreferences().attachmentsMaxFileSize;

    if (file.size < maxFileSize * 1024) { //in bytes
      setSelectedFile(file);
      setErrors(null);
      return;
    }

    let data = {
      errorCode: 'UF_10003',
      message : labels.get('errors.filesize', undefined, {maxSize: maxFileSize} ),
      statusType:'error'
    };

    setErrors(data);
  };

  const onClearHandler = () => {
    setSelectedFile(null);
    setErrors(null);
  }

  const renderErrors = () => {
    if (!errors){
      return null;
    }

    const icon = 'pl pl-warning-icon';
    let errorType = errors.statusType;

    return (
      <div className="error-selection">
        <div className="error-item">
          <span className={`error-icon ${icon} ${errorType}`} />
          <label className='error-msg'>{errors.message}</label>
        </div>
      </div>
    );
  }

  const getDialogButtons = () => {
    return {
      left: [
        {
          id: 'cancel',
          text: dialogLabels.get('cancel'),
          action: actions.hide,
        },
      ],
      right: [
        {
          id: 'submit',
          text: dialogLabels.get('ok'),
          bsStyle: 'primary',
          loading: sData.get('loading'),
          action: handleSubmit(onSubmit),
          disabled: sData.get('loading'),
        },
      ],
    };
  };

  return (
    <Dialog
      id="qpl-acceptance-decision-dialog"
      className="qpl-acceptance-decision-dialog"
      titleText={labels.get(titleKey)}
      show={true}
      onHide={onHide}
      sData={sData}
      footerButtons={getDialogButtons()}
    >

      <InputSection htmlFor="comments" className="no-margin" label={labels.get('comments')}>
        <TextAreaField id="comments" name="comments" rows={5}
                       placeholder={labels.get('comments.placeholder')}/>
      </InputSection>

      <PL_FilePicker
        name="selectedFileName"
        placeHolder={labels.get('selectFilePlaceholder')}
        buttonText={selectedFile ? dialogLabels.get('changeFile') : dialogLabels.get('browse')}
        accept={getCoCAttachmentAcceptGenericTypes()}
        disabled={isLoading()}
        selectedFile={selectedFile}
        onSelectedFileChanged={handleSelectedFileChanged}
        onClear={onClearHandler}
        isClearable={true}
      />

      {renderErrors()}

      <div className='user-info-section'>
        {<div>{`${loggedInUser.firstName} ${loggedInUser.lastName}`}</div>}
        {<div>{`${loggedInUser.email ?? ''}`}</div>}
      </div>

    </Dialog>
  );
}

QplAcceptanceDecisionDialog.propTypes = {
  actions: PropTypes.object.isRequired,
  sData: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  reloadParentComponent: PropTypes.func,
};

export default reduxForm({
  form: 'qplAcceptanceDecisionDialog',
})(QplAcceptanceDecisionDialog);
